import React, { PureComponent } from 'react'
import { Form as AntdForm, Input, Select, Switch, message } from 'antd'
import { FormComponentProps } from 'antd/es/form'
import api from './../../api'
import styles from './style.module.less'
import IPayment from './../../models/payment'
import MultipleImgUpload from './../../components/upload/multipleImgUpload'

interface IReciveProps extends FormComponentProps {
  onRef: (form: Form) => void
  complete: (payment: IPayment) => void
  validateFail: () => void
  data: IPayment
  totalSum: number
  isEdit?: boolean
}

class Form extends PureComponent<IReciveProps, any> {
  submit = () => {
    this.props.form.validateFields((err: any, values: IPayment) => {
      if (this.props.totalSum < values.money) {
        message.error('记账金额大于总欠款')
        this.props.validateFail()
      } else if (err) {
        this.props.validateFail()
      } else {
        api.payment
          .createOrUpdate(values)
          .then(res => {
            if (res.status === 200) {
              this.props.complete(res.data)
            }
          })
          .catch(() => {
            this.props.validateFail()
          })
      }
    })
  }
  componentDidMount() {
    this.props.onRef(this)
  }
  render() {
    const { isEdit } = this.props
    const { getFieldDecorator } = this.props.form
    return (
      <AntdForm
        labelCol={{ span: 6 }}
        wrapperCol={{ span: 16 }}
        labelAlign="right"
        className={styles.form}
      >
        <AntdForm.Item label="" className={styles.displayNone}>
          {getFieldDecorator('id', {
            rules: [{ required: false, message: '' }],
            initialValue: this.props.data['id']
          })(<Input placeholder="" />)}
        </AntdForm.Item>
        <AntdForm.Item label="记账金额" className={styles.displayNormal}>
          {getFieldDecorator('money', {
            rules: [{ required: true, message: '记账金额' }],
            initialValue: this.props.data['money']
          })(<Input placeholder="记账金额" />)}
        </AntdForm.Item>
        <AntdForm.Item label="付款金额" className={styles.displayNormal}>
          {getFieldDecorator('realMoney', {
            rules: [{ required: true, message: '付款金额' }],
            initialValue: this.props.data['realMoney']
          })(<Input placeholder="付款金额" />)}
        </AntdForm.Item>
        <AntdForm.Item label="备注" className={styles.displayNormal}>
          {getFieldDecorator('remark', {
            rules: [{ required: false, message: '备注' }],
            initialValue: this.props.data['remark']
          })(<Input placeholder="备注" />)}
        </AntdForm.Item>
        <AntdForm.Item label="图片" className={styles.displayNormal}>
          {getFieldDecorator('pic', {
            rules: [{ required: false, message: '图片' }],
            initialValue: this.props.data.pic
          })(<Input placeholder="图片" disabled={true} />)}
          <MultipleImgUpload
            path="payment"
            fail={msg => {
              message.warning(msg)
            }}
            success={url => {
              this.props.form.setFieldsValue({
                pic: url
              })
            }}
            defaultUrls={!!this.props.data.pic ? this.props.data.pic : []}
          />
        </AntdForm.Item>
        <AntdForm.Item label="客户" className={styles.displayNone}>
          {getFieldDecorator('customerId', {
            rules: [{ required: false, message: '客户' }],
            initialValue: this.props.data['customerId']
          })(<Input placeholder="客户" />)}
        </AntdForm.Item>
      </AntdForm>
    )
  }
}

export default AntdForm.create<IReciveProps>({
  onValuesChange(props, changedValues, allValues) {
    if (changedValues.money) {
      props.form.setFieldsValue({
        realMoney: changedValues.money
      })
    }
  }
})(Form)
